import { MutationHookOptions, useMutation } from '@apollo/client';

import { CreateExportJobDocument, CreateExportJobMutation, CreateExportJobMutationVariables } from './exportJob.gql';

const defaultOptions = {} as const;

export function useCreateExportJobMutation(
  baseOptions?: MutationHookOptions<
  CreateExportJobMutation,
  CreateExportJobMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation<CreateExportJobMutation, CreateExportJobMutationVariables>(
    CreateExportJobDocument,
    options,
  );
}
